<template>
  <v-container class="ma-0 pa-0 container-presentational fill-height">
    <v-row class="fill-height">
      <v-col
        cols="12"
        md="6"
        class="px-6 py-8 px-md-36 py-md-20"
        :style="{'min-height': '100vh'}"
      >
        <TheAppLogo class="mb-2 mb-md-20" />
        <slot />
      </v-col>
      <v-col :cols="6" class="d-none d-md-block pa-0">
        <v-img
          :src="require('@/assets/images/main-image.jpeg')"
          height="100%"
          width="100%"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TheAppLogo from '@/views/containers/TheAppLogo.vue';

export default {
  components: {
    TheAppLogo,
  },
};
</script>
